export const setLensesTutorialToStorage = () => {
  localStorage.setItem('lensesTutorial', 'shown');
};
